import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { StyledHeader } from './StyledHeader';

export type ContainerType = 'normal' | 'wide' | 'userList';

type Props = {
  headerTitle?: string;
  hasHeaderDivider: boolean;
  hasInnerWrapper: boolean;
  containerType: ContainerType;
  children: ReactNode;
};

export const StyledContainer: React.FC<Props> = (props) => {
  const {
    children,
    headerTitle,
    hasInnerWrapper,
    hasHeaderDivider,
    containerType,
  } = props;

  return (
    <Wrapper $containerType={containerType}>
      {hasInnerWrapper ? (
        <InnerWrapper>
          {headerTitle && <StyledHeader>{headerTitle}</StyledHeader>}
          {hasHeaderDivider && <Divider />}
          {children}
        </InnerWrapper>
      ) : (
        <>
          {headerTitle && <StyledHeader>{headerTitle}</StyledHeader>}
          {hasHeaderDivider && <Divider />}
          {children}
        </>
      )}
    </Wrapper>
  );
};

const Divider = styled.div`
  padding: 1px 0;
  margin: 14px auto;
`;

const InnerWrapper = styled.div`
  margin: 3em auto;
`;

const NormalStyle = css`
  width: 700px;
  padding: 0 0 48px;
`;

const WideStyle = css`
  width: 930px;
  padding: 0 0 48px;
`;

const UserListStyle = css`
  width: 960px;
  padding-top: 48px;
  margin: 0 auto;
`;

export const Wrapper = styled.div<{ $containerType?: ContainerType }>`
  margin: 0 auto;
  font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  flex: 1 0 auto;
  ${({ $containerType }) =>
    ($containerType === 'normal' && NormalStyle) ||
    ($containerType === 'wide' && WideStyle) ||
    ($containerType === 'userList' && UserListStyle)}
`;
